module.exports = __webpack_public_path__ + "img/Mail.8f65ba00.svg";